import axios from "axios";

const getAdtInfoSnListing = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/serialnumber/api/v1/additional-info/serialnumbers`, {
        length: parameters.length,
        start: parameters.start,
        search: parameters.search,
        order: parameters.order,
        column: parameters.column,
        draw: parameters.draw,
        search_column: parameters.searchColumn,
        node_uuids: parameters.node_uuids,
        product_uuids: parameters.product_uuids,
        status: parameters.status,
        product_not_assigned: parameters.productNotAssigned,
        additional_info_uuids: parameters.additional_info_uuids,
        additional_info: parameters.additionalInfo,
        after_key: parameters.afterKey,
        display_lang: parameters.displayLang,
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAdtInfoSnListing;
